var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};
MDB.Charts.renderers = MDB.Charts.renderers || {};

MDB.Charts.renderers.linearGauge = function (widget, chart, data, metadata) {
    var container = $('<div class="linear-gauge">').width('90%').height('90%').css({ top: '5%', left: '5%' });
    var kendoFunc = container.kendoLinearGauge;

    MDB.Charts.renderKendoGauge(widget, chart, data, metadata, container, kendoFunc);
};